import React, { useEffect, useState, useCallback, useMemo } from "react";
import CarMovementIcon from "assets/svgIcons/AdminDashboard/CarMovementIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import {
  SITEID_GLOBAL_STATE,
  DASHBOARD_GLOBAL_STATE
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";
import { PaceReportModal } from "../PaceReports/PaceReportModal";

// Time formatting helper component
const TimeDisplay = ({ date, timeZoneOffset, label, value }) => {
  const { t } = useTranslation();

  const formattedTime = useMemo(() => {
    if (!date) return "";
    return moment
      .utc(date)
      .utcOffset(-timeZoneOffset)
      .format("LT");
  }, [date, timeZoneOffset]);

  return (
    <li style={{ alignItems: "flex-start" }}>
      <p style={{ minWidth: "110px", maxWidth: "110px", marginRight: "10px" }}>{t(label)}</p>
      <p style={{ fontSize: 15, fontWeight: 500, lineHeight: "25px",maxHeight: "100px",minHeight:"30px" , whiteSpace: "pre-line", flex: 1, textAlign: "left"}}>{value ? value : formattedTime}</p>
    </li>
  );
};

const CarMovement = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { paceReportData } = useHookstate(DASHBOARD_GLOBAL_STATE);
  const dispatch = useDispatch();
  const [openAlertModal, setOpenAlertModal] = useState(false);

  // Redux selectors
  const {
    getCarMovementState,
    siteSettingsData,
    getDashboardFeatureSetStatus,
    getCarSelectionState,
    getCarsData
  } = useSelector((state) => state?.commonReducers) || [];

  // Memoized current course ID
  const dashCourseId = useMemo(() => localStorage.getItem("dashCourseId"), []);

  // Memoized current date calculation
  const currentQueryDate = useMemo(() => {
    if (!siteSettingsData?.TimeZoneOffset) return null;
    return moment(new Date())
      .utc()
      .utcOffset(-siteSettingsData.TimeZoneOffset)
      .format("YYYY-MM-DD");
  }, [siteSettingsData?.TimeZoneOffset]);

  // Fetch car movement data
  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0 &&
      currentQueryDate
    ) {
      dispatch(
        COMMON_SERVICES.getCarMovementServices(
          siteId.get(),
          currentQueryDate,
          dashCourseId,
          72
        )
      );
    }
  }, [
    siteId.get(),
    dashCourseId,
  ]);

  // Handle modal state based on global pace report data
  const handleModalState = useCallback(() => {
    if (paceReportData.get() === "car-movement") {
      setOpenAlertModal(true);
    }
  }, [paceReportData]);

  useEffect(() => {
    handleModalState();
  }, [handleModalState]);

  return (
    <>
      <PaceReportModal
        openAlertModal={openAlertModal}
        setOpenAlertModal={setOpenAlertModal}
      />
      <div className="header">
        <CarMovementIcon />
        <p>{t("Car_movement")}</p>
      </div>
      <div data-section="car-movement" className="box-body car-round-status">
        <ul><TimeDisplay
          date={getCarMovementState && getCarMovementState?.FirstCarMovementRoundDate}
          timeZoneOffset={siteSettingsData?.TimeZoneOffset}
          label="First_car_round"
        />
          <TimeDisplay
            date={getCarMovementState && getCarMovementState?.LastCarMovementRoundDate}
            timeZoneOffset={siteSettingsData?.TimeZoneOffset}
            label="Last_car_round"
          />
          <TimeDisplay
            label="On_charge"
            value={getCarSelectionState && getCarSelectionState[0]?.Oncharge}
          />
          <TimeDisplay
            value={getCarMovementState && getCarMovementState?.AllCarOnCharge ? 
              getCarMovementState?.AllCarOnCharge + " " + t("Out_of") + " " + Object.keys(getCarsData).length + " " +t("Cars") +"\n" + t("On_charge_as_of") + " " + moment.utc(getCarMovementState?.LastTimeCharge).utcOffset(-siteSettingsData?.TimeZoneOffset).format("MM/DD/YYYY LT") 
              : " "}
            label="All_Cars_on_charge"
          />

        </ul>

      </div>
    </>
  );
};

export default CarMovement;
